import PageLayout from 'pages/SignUp/PageLayout';
import PageProvider from 'pages/SignUp/PageProvider';

const SignUpPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default SignUpPage;
